import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, filter, map, take } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import {
  DASHBOARD,
  LOGOUT,
  MAPS,
  PANAROMA,
  SUBPANAROMA,
  TRACE,
} from 'src/app/shared/routeLink.constant';
import { CommonService } from 'src/app/shared/service/common.service';
import { selectSelectedVehicle } from 'src/app/store/user/user.selectors';
import { selectUserMenuList } from 'src/app/store/userMenuList/userMenuList.selector';

export const landingResolver: ResolveFn<string> = () => {
  const store = inject(Store);
  const authService = inject(AuthService);
  const commonService = inject(CommonService);

  if (!commonService.getlocalStorageItem('token')) {
    return `/${LOGOUT}`;
  }

  return combineLatest([
    store.select(selectSelectedVehicle).pipe(take(1)),
    store.select(selectUserMenuList).pipe(
      filter((menu) => !!menu && menu.length > 0),
      take(1)
    ),
  ]).pipe(
    map(([vehicleType, menuList]) => {
      const dashboardUrl = `/${PANAROMA}/${DASHBOARD}`;
      const subPanaromaUrl = `/${PANAROMA}/${SUBPANAROMA}`;
      const logoutUrl = `/${LOGOUT}`;
      const mapUrl = `/${TRACE}/${MAPS}`;

      // No vehicle selected
      if (!vehicleType) {
        return logoutUrl;
      }

      const hasDashboardAccess = authService.isScreenAccess(
        dashboardUrl,
        menuList
      );
      const hasPanoramaAccess = authService.isScreenAccess(
        subPanaromaUrl,
        menuList
      );

      if (!hasDashboardAccess && !hasPanoramaAccess) {
        return mapUrl;
      } else if (vehicleType?.code === 'VC04' || vehicleType?.code === 'VC03') {
        return hasDashboardAccess ? dashboardUrl : `/${PANAROMA}`;
      }

      // Truck, Tractor
      return subPanaromaUrl;
    })
  );
};
